// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6454":"Widgets","6821":"plone-volto-components-theme-InjectPloneComponentsCSS-InjectPloneComponentsCSS","7051":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] + "." + {"6454":"1eb7aa6b","6821":"f7655845","7051":"2b1266ba"}[chunkId] + ".chunk.css";
};